export const siteInfo = {
  name: '同人动画创作指南',
  tagline: '从零到成品，让你的故事动起来',
  description: '深入了解同人动画的创作流程、工具选择与发布渠道。无论你是动画新手还是资深同人创作者，本页为你提供完整的同人动画制作攻略，帮助你将脑海中的故事变成精彩动画作品，快速融入同人动画社群。',
  keywords: '同人动画,同人动画制作教程,同人动画软件推荐,同人动画投稿平台,原创同人动画,二次元同人动画,同人动画社区',
  url: 'https://doujin-animation-guide.com',
  author: '同人动画创作指南团队',
  foundingYear: '2020',
  stats: {
    articles: '150+',
    readers: '50,000+',
    contributors: '30+',
    years: '6',
  },
  contact: {
    email: 'hello@doujin-animation-guide.com',
    weibo: '@同人动画创作指南',
    bilibili: '同人动画创作指南',
  },
  navLinks: [
    { name: '首页', href: '/' },
    { name: '动画制作教程', href: '/category/tutorials' },
    { name: '软件推荐', href: '/category/software' },
    { name: '投稿平台', href: '/category/platforms' },
    { name: '创作心得', href: '/category/tips' },
    { name: '社群动态', href: '/category/community' },
    { name: '关于我们', href: '/about' },
  ],
};